/**
 * CheckStatus.jsx — Bouton compact à 4 états (à découvrir / en cours / acquis / à retravailler).
 *
 * Clic  = passe à l'état suivant (cyclique).
 * Clic droit ou Alt+clic = revient à l'état précédent.
 *
 * Utilisé par le livret Topolino AM. Rendu :
 *  • disque coloré selon l'état (gris → orange → vert → rouge)
 *  • label court en tooltip et aria-label
 */
import React from 'react';
import { Check, Circle, RotateCcw, AlertTriangle } from 'lucide-react';
import { CHECK_STATES, nextState } from '../../data/livrets/livretTopolinoAM';

const ICON_BY_STATE = {
  todo:          (cls) => <Circle className={cls} />,
  wip:           (cls) => <RotateCcw className={cls} />,
  ok:            (cls) => <Check className={cls} />,
  retravailler:  (cls) => <AlertTriangle className={cls} />,
};

export function CheckStatus({ value, onChange, testid, size = 'md' }) {
  const current = value && CHECK_STATES.some((s) => s.key === value) ? value : 'todo';
  const meta = CHECK_STATES.find((s) => s.key === current);
  const Icon = ICON_BY_STATE[current] || ICON_BY_STATE.todo;

  const dims = size === 'sm' ? 'w-6 h-6' : 'w-7 h-7';
  const iconSize = size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4';

  const handleClick = (e) => {
    if (e.altKey || e.shiftKey) {
      // Retour arrière
      const idx = CHECK_STATES.findIndex((s) => s.key === current);
      const prev = CHECK_STATES[(idx - 1 + CHECK_STATES.length) % CHECK_STATES.length];
      onChange(prev.key);
      return;
    }
    onChange(nextState(current));
  };

  const handleContext = (e) => {
    e.preventDefault();
    const idx = CHECK_STATES.findIndex((s) => s.key === current);
    const prev = CHECK_STATES[(idx - 1 + CHECK_STATES.length) % CHECK_STATES.length];
    onChange(prev.key);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      onContextMenu={handleContext}
      className={`shrink-0 ${dims} rounded-full border-2 flex items-center justify-center transition text-white`}
      style={{
        background: current === 'todo' ? 'transparent' : meta.color,
        borderColor: meta.color,
        color: current === 'todo' ? meta.color : 'white',
      }}
      data-testid={testid || `check-${current}`}
      data-state={current}
      aria-label={`État : ${meta.label}. Cliquer pour passer à l'état suivant.`}
      title={`${meta.label} — clic pour changer, Alt+clic pour revenir en arrière`}
    >
      {Icon(iconSize)}
    </button>
  );
}

export default CheckStatus;
